"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var WaitListModel = /** @class */ (function () {
    function WaitListModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/wait-lists",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    WaitListModel.prototype.extract = function (result) {
        return result.data;
    };
    WaitListModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    WaitListModel.prototype.getWaitLists = function (params) {
        var url = this.URLS.FETCH;
        if (params) {
            var query = (0, queryString_1.toQueryString)(params);
            if (query) {
                url += "?" + query;
            }
        }
        return this.$http.get(url).then(this.cacheResults);
    };
    WaitListModel.prototype.create = function (data) {
        return this.$http
            .post(this.URLS.FETCH, data)
            .then(this.cacheResults);
    };
    WaitListModel.prototype.getAvailable = function (params) {
        var query = (0, queryString_1.toQueryString)(params);
        return this.$http
            .get(this.URLS.FETCH + "/available?" + query)
            .then(this.cacheResults);
    };
    WaitListModel.prototype.destroy = function (id) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    return WaitListModel;
}());
WaitListModel.$inject = ["$http", "APPURL"];
exports.default = WaitListModel;
